import { motion, useReducedMotion } from "motion/react";

interface Props {
  text: string;
  className?: string;
  as?: "h1" | "h2" | "h3" | "p";
  /** Stagger between words, seconds. Default 0.07. */
  stagger?: number;
  delay?: number;
}

/**
 * Word-by-word reveal for editorial serif headlines.
 * Splits on whitespace, preserves spaces, masks each word with overflow-hidden.
 */
const SerifReveal = ({
  text,
  className,
  as: Tag = "h1",
  stagger = 0.07,
  delay = 0,
}: Props) => {
  const reduce = useReducedMotion();
  const words = text.split(" ");

  if (reduce) {
    return <Tag className={className}>{text}</Tag>;
  }

  return (
    <Tag className={className} aria-label={text}>
      {words.map((word, i) => (
        <span
          key={`${word}-${i}`}
          aria-hidden
          className="inline-block overflow-hidden align-bottom"
          style={{ marginRight: i < words.length - 1 ? "0.25em" : 0 }}
        >
          <motion.span
            className="inline-block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{
              duration: 0.8,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {word}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export default SerifReveal;
